export default __webpack_public_path__ + "static/media/hiw-slide-5b.a3579088.png";